import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tex",
  "use": "icon-tex-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tex\"><path fill=\"#333333\" d=\"M857.088 5.12v131.072H5.12V5.12m161.792 293.888h851.968v132.096H166.912V299.008zM5.12 591.872h851.968v132.096H5.12V591.872z m161.792 294.912h851.968v132.096H166.912V886.784z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol